export default __webpack_public_path__ + "static/media/phonegirl@3x.85f674ee.png";